import { orderBy } from 'lodash';
import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	const mappedData = data.map((r: PropertyType) => ({
		name: r.name,
		color: r.color,
		permissions: r.permissions,
		members: r.profiles_count,
		isChecked: false,
	}));
	return orderBy(mappedData, [(role) => role.name.toLowerCase()]);
};
